import { getCurrencySymbol } from 'components/modules/master/formatters';
import { roundTo } from 'utils/formatters/Precision';
var accounting = require('accounting');
const defaultCurrency = DEFAULT_CURRENCY


const formatMoney = function (value, currency = defaultCurrency) {
  let amount = (value && typeof (value) == 'number') ? roundTo(value, 2) : value;
  return accounting.formatMoney(amount, {
    format: {
      pos: '%s%v',
      neg: '-%s%v',
      zero: '%s%v',
    },
    symbol: getCurrencySymbol(currency) || "$",
  });
};

export default formatMoney;
